import { TYPES } from "../actions";

const initialState = {
  bankBrands: [],
  totalCount: 0,
  currentBankBrand: null,
  searchResults: [],
  logos: null,
  loading: false
};

export const tkt1BankBrandReducer = (state = initialState, action) => {
  switch (action.type) {

    case TYPES.ACTION_GET_TKT1_BANK_BRANDS_SUCCESS:
      return { 
        ...state, 
        bankBrands: action.payload.data.data, 
        totalCount: action.payload.data.pagination ? action.payload.data.pagination.total_count : state.totalCount,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_BANK_BRANDS_FAIL:
      return { 
        ...state, 
        bankBrands: [],
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_BANK_BRAND_BY_ID_SUCCESS:
      return { 
        ...state, 
        currentBankBrand: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_BANK_BRAND_BY_ID_FAIL:
      return { 
        ...state, 
        currentBankBrand: null,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_BANK_BRAND_BY_CODE_SUCCESS:
      return { 
        ...state, 
        currentBankBrand: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_BANK_BRAND_BY_CODE_FAIL:
      return { 
        ...state, 
        currentBankBrand: null,
        loading: false
      };

    case TYPES.ACTION_SEARCH_TKT1_BANK_BRANDS_SUCCESS:
      return { 
        ...state, 
        searchResults: action.payload.data.data || action.payload.data,
        loading: false
      };

    case TYPES.ACTION_SEARCH_TKT1_BANK_BRANDS_FAIL:
      return { 
        ...state, 
        searchResults: [],
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_BANK_BRAND_SUCCESS:
      return { 
        ...state, 
        bankBrands: [action.payload.data, ...state.bankBrands],
        totalCount: state.totalCount + 1,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_BANK_BRAND_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_BANK_BRAND_SUCCESS:
      return { 
        ...state, 
        bankBrands: state.bankBrands.map(brand => 
          brand._id === action.payload.data._id ? action.payload.data : brand
        ),
        currentBankBrand: state.currentBankBrand && state.currentBankBrand._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentBankBrand,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_BANK_BRAND_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_BANK_BRAND_SUCCESS:
      return { 
        ...state, 
        bankBrands: state.bankBrands.filter(brand => brand._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentBankBrand: state.currentBankBrand && state.currentBankBrand._id === action.payload.id 
          ? null 
          : state.currentBankBrand,
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_BANK_BRAND_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_BANK_BRAND_LOGOS_SUCCESS:
      return { 
        ...state, 
        logos: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_BANK_BRAND_LOGOS_FAIL:
      return { 
        ...state, 
        logos: null,
        loading: false
      };
      
    default:
      return state;
  }
};
